import { Modal, Typography } from 'antd';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import { ModalProps } from 'models';

import './modal.scss';

interface ModalComponentProps extends ModalProps {
	icon?: ReactNode;
	title?: string | ReactNode;
	className?: any;
	children: ReactNode;
	maskClosable?: boolean;
	width?: string;
}

export const ModalComponent: FC<ModalComponentProps> = ({
	isOpen,
	onClose,
	icon,
	title,
	children,
	className,
	maskClosable = true,
	width = '406px',
}) => {
	return (
		<Modal
			width={width}
			className={classNames('modal', { [className]: className })}
			open={isOpen}
			onCancel={onClose}
			closeIcon={<CloseIcon />}
			destroyOnClose
			maskClosable={maskClosable}
		>
			{icon && <div className="modal-icon">{icon}</div>}
			{title && (
				<Typography.Title level={4} className="modal-title">
					{title}
				</Typography.Title>
			)}
			{children}
		</Modal>
	);
};
